module.exports = __webpack_public_path__ + "static/img/3.ae7383d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/logos/3.svg
// module id = 698
// module chunks = 1